import { useDispatch, useSelector } from "react-redux";
import { Grid, Slider, Typography,FormControl, ToggleButtonGroup, ToggleButton, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { selectFBA, setFBASettings } from "../../reducers/fbaSlice";
import { fbaUnits } from "./fbaUnits";
// import { fbaConversionFactors } from "./fbaConversionFactors";
// import { f_TO_C } from "../../helpers/conversionFactors";

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    margin: '10px 0',
    padding: 10,
    backgroundColor: 'transparent',
  },
  input: {
    width: 90,
  },
}));

export const FBASetting = ({ parameter, fbaSettings, setFbaSettings, darkMode }) => {

  const classes = useStyles();
  const dispatch = useDispatch();
  const fba = useSelector(selectFBA);
  const currentFBA = fba?.byId?.[fba?.currentFBAId];

  const globalUnits = currentFBA?.settings?.units?.value;

  const handleInputChange = async (value, parameter, fba) => {
    try {


      if (isNaN(value) || (
        (parameter === 'p_p' || 
        parameter === 'type' || 
        parameter === 'flow' || 
        parameter === 'shape' || 
        parameter === 'c_c' ||
        parameter === 'c_phi' ||
        parameter === 'c_fluid' ||
        parameter === 'useSkinLinearFlowTypeCurve' ||
        parameter === 'lfSkinModel' ||
        parameter === 'temperatureMethod' ||
        parameter === 'pressureMethod' ||
        parameter === 'frictionFactorMethod') && !value > 0)) return;
      
      let newValue = String(value);

      // Check if the input starts with a dot
      if (newValue.startsWith('.')) {
        // If it does, prepend '0' to the input newValue
        newValue = '0' + newValue;
      };

      if (parameter === 'n2' ||
        parameter === 'co2' ||
        parameter === 'h2s' ||
        parameter === 'solids_bbt' ||
        parameter === 'solids_abt' ||
        parameter === 'phi_m' ||
        parameter === 's_w' ||
        parameter === 's_o' ||
        parameter === 'phi_f' ||
        parameter === 'mobileOilSaturation' ||
        parameter === 'mobileGasSaturation' ||
        parameter === 'wtPercentSolidsMatrixInflow'
      ) {
        newValue = Number((value / 100).toFixed(5));
      } else if (parameter === 'skinMatrixInflow') {
        newValue = Number((value / 1000)?.toFixed(10));
      } else {
        newValue = Number(value);
      };

      // // Convert value back to field units
      // if (globalUnits === 'metric') {
      //   if (parameter === 't_r' || parameter === 'wht') {
      //     newValue = newValue * (9 / 5) + 32;
      //   } else if (parameter === 'geothermalGradient') {
      //     newValue = +((newValue * (9 / 5) / 3.28)?.toFixed(3));
      //   } else if (parameter === 'multiPhaseFitIntercept' && fbaSettings?.type === 2) {
      //     newValue = fbaConversionFactors[parameter] ? (value / fbaConversionFactors[parameter]) : value
      //   } else {
      //     newValue = fbaConversionFactors[parameter] ? +((newValue / fbaConversionFactors[parameter])?.toFixed(6)) : newValue;
      //   };
      // };


      if (
        parameter === 'analysisType' || 
        parameter === 'multiPhaseFitIntercept' || 
        parameter === 'linearFlowFitIntercept' || 
        parameter === 'linearFlowFitInterceptI' || 
        parameter === 'fractureDepletionFitIntercept' ||
        parameter === 'fractureDepletionFitInterceptI' ||
        parameter === 'linearFlowEndTmb' ||
        parameter === 'sqrtTimeFitSlope' ||
        parameter === 'sqrtTimeFitIntercept' ||
        parameter === 'fmbFitSlope' ||
        parameter === 'fmbFitIntercept'
      ) { // for real-time updates
        dispatch(setFBASettings({fbaId: fba.id, settings: {...fbaSettings, [parameter]: {...fbaSettings[parameter], value: Number(newValue)}}}));
      };
      let newParameter = {...fbaSettings?.[parameter], value: (Number(newValue) || 0)};
      let newFbaSettings = {...fbaSettings, [parameter]: newParameter};
      
      if (parameter === 'solids_abt') {
        newFbaSettings.wtPercentSolidsMatrixInflow = {...newFbaSettings.wtPercentSolidsMatrixInflow, value: (Number(newValue) || 0)};
      };

      setFbaSettings({...newFbaSettings});

    } catch (error) {
      console.log('Could not update FBA parameter!');
      console.log(error);
      return;
    };
  };

  let value;
  if (parameter === 'n2' ||
    parameter === 'co2' ||
    parameter === 'h2s' ||
    parameter === 'solids_bbt' ||
    parameter === 'solids_abt' ||
    parameter === 'phi_m' ||
    parameter === 's_w' ||
    parameter === 's_o' ||
    parameter === 'phi_f' ||
    parameter === 'mobileOilSaturation' ||
    parameter === 'mobileGasSaturation' ||
    parameter === 'wtPercentSolidsMatrixInflow'
  ) {
    value = Number((+fbaSettings?.[parameter]?.value * 100).toFixed(5));
  } else if (parameter === 'skinMatrixInflow') {
    value = Number((+fbaSettings?.[parameter]?.value * 1000).toFixed(10));
  } else {
    if (
      parameter === 'multiPhaseFitIntercept' || 
      parameter === 'linearFlowFitIntercept' || 
      parameter === 'linearFlowFitInterceptI' || 
      parameter === 'fractureDepletionFitIntercept' ||
      parameter === 'fractureDepletionFitInterceptI' ||
      parameter === 'linearFlowEndTmb'
    ) {
      value = Number(currentFBA?.settings?.[parameter]?.value);
    } else {
      value = Number(fbaSettings?.[parameter]?.value);
    };
  };

  // // convert value units
  // if (globalUnits === 'metric') {
  //   if (parameter === 't_r' || parameter === 'wht') {
  //     value = parseInt(f_TO_C(value));
  //   } else if (parameter === 'geothermalGradient') {
  //     value = +(((value) * (5 / 9) * 3.28)?.toFixed(3));
  //   } else if (parameter === 'multiPhaseFitIntercept' && fbaSettings?.type === 2) {
  //     value = fbaConversionFactors[parameter] ? (value * fbaConversionFactors[parameter]) : value;
  //   } else {
  //     value = fbaConversionFactors[parameter] ? +((value * fbaConversionFactors[parameter])?.toFixed(6)) : value;
  //   };

  //   if (
  //     parameter === 'p_fi' ||
  //     parameter === 'drainageAreaPreBT' ||
  //     parameter === 'drainageAreaPostBT' ||
  //     parameter === 'gor' ||
  //     parameter === 'loadFluidPumped'
  //   ) {
  //     value = Number(value.toFixed(1));
  //   };
  // };

  
  const name = fbaSettings?.[parameter]?.name || "Parameter";
  const unit = getFBAUnit(parameter, fbaSettings?.[parameter]?.unit, globalUnits);

  if (isNaN(value)) {
    return <></>
  } else if (
    parameter === 'flow' || 
    parameter === 'shape' || 
    parameter === 'c_c' ||
    parameter === 'c_phi' ||
    parameter === 'c_fluid' ||
    parameter === 'useSkinLinearFlowTypeCurve' ||
    parameter === 'lfSkinModel' ||
    parameter === 'temperatureMethod' ||
    parameter === 'pressureMethod' ||
    parameter === 'frictionFactorMethod'
    ) {
    return (
      <FormControl component="fieldset" style={{width: '100%', padding: '0 10px', marginTop: 10}}>
        <Typography size={10}>{name}</Typography>
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={(e, newValue) => handleInputChange(newValue, parameter, currentFBA)}
          size="small"
          style={{height: 30, width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 20, marginTop: 10}}
        >
          <ToggleButton value={1} size="small" style={{width: '50%'}} color={(darkMode ? "" : "primary")}>
            <Typography style={{fontSize: 12}}>
              {getSwitchButtonName(parameter)[0]}
            </Typography>
          </ToggleButton>
          <ToggleButton value={2} size="small" style={{width: '50%'}} color={(darkMode ? "" : "primary")}>
            <Typography style={{fontSize: 12}}>
              {getSwitchButtonName(parameter)[1]}
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>
    )
  } else if (parameter === 'analysisType') {
    return (
      <FormControl component="fieldset" style={{width: '100%', padding: '0 10px', marginTop: 10}}>
        <Typography size={10}>Analysis Type</Typography>
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={(e, newValue) => handleInputChange(newValue, parameter, currentFBA)}
          size="small"
          style={{height: 30, width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 20, marginTop: 10}}
        >
          <ToggleButton value={1} size="small" style={{width: '50%'}} color={(darkMode ? "" : "primary")}>
            <Typography style={{fontSize: 12}}>
              QuickLook
            </Typography>
          </ToggleButton>
          <ToggleButton value={2} size="small" style={{width: '50%'}} color={(darkMode ? "" : "primary")}>
            <Typography style={{fontSize: 12}}>
              Advanced
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>
    )
  } else if (parameter === 'type') {
    return (
      <FormControl component="fieldset" style={{width: '100%', padding: '0 10px', marginTop: 10}}>
        <Typography size={10}>{name}</Typography>
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={(e, newValue) => handleInputChange(newValue, parameter, currentFBA)}
          size="small"
          style={{height: 30, width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 20, marginTop: 10}}
        >
          <ToggleButton value={1} size="small" style={{width: '33%'}} color={(darkMode ? "" : "primary")}>
            <Typography style={{fontSize: 12}}>
              Tight Oil
            </Typography>
          </ToggleButton>
          <ToggleButton value={2} size="small" style={{width: '33%'}} color={(darkMode ? "" : "primary")}>
            <Typography style={{fontSize: 12}}>
              Tight Gas
            </Typography>
          </ToggleButton>
          <ToggleButton value={3} size="small" style={{width: '33%'}} color={(darkMode ? "" : "primary")} disabled>
            <Typography style={{fontSize: 12}}>
              Shale Gas
            </Typography>
          </ToggleButton>
        </ToggleButtonGroup>
      </FormControl>
    )
  } else {

    return (
      <div className={classes.root}>
        <Typography id='input-slider' gutterBottom noWrap>
          {name} <span style={{fontSize: 12}}>{unit}</span>
        </Typography>
        
        <Grid container spacing={2} alignItems="center">
          <Grid item xs style={{margin: '0 10px'}}>
            <Slider
              value={Number(value)}
              onChange={(e, newValue) => handleInputChange(newValue, parameter, currentFBA)}
              min={getMinMaxStep(parameter, value, globalUnits)?.[0]}
              max={getMinMaxStep(parameter, value, globalUnits)?.[1]}
              step={getMinMaxStep(parameter, value, globalUnits)?.[2]}
              valueLabelDisplay="auto"
              style={{color: (darkMode ? '#fff' : '#0758B7')}}
            />
          </Grid>
          <Grid item>
            <TextField
              className={classes.input}
              variant="standard"
              value={value}
              margin="dense"
              size="small"
              onChange={(e) => handleInputChange(e.target.value, parameter, currentFBA)}
              type='number'
              inputProps={{
                min: getMinMaxStep(parameter, value, globalUnits)?.[0],
                max: getMinMaxStep(parameter, value, globalUnits)?.[1],
                step: getMinMaxStep(parameter, value, globalUnits)?.[2],
                type: 'number',
                inputMode: 'decimal'
              }}
              onFocus={event => {
                event.target.select();
              }}
            />
          </Grid>
        </Grid>

      </div>
    );
  };
};

// FUNCTIONS
// function isInputError(value) {
//   return String(value)?.length === 0;
// };
// function roundToSignificantFigures(number, significantFigures) {
//   try {
//     if (!number || !significantFigures) return 0;
    
//     const multiplier = Math.pow(10, significantFigures - Math.floor(Math.log10(Math.abs(number))) - 1);
//     return Math.round(number * multiplier) / multiplier;
//   } catch (error) {
//     console.log(error);
//     return 0;
//   };
// };

function getSwitchButtonName(param) {
  try {
    switch(param) {
      case 'p_p':
        return ['Water','Oil'];
      case 'flow':
        return ['Radial', 'Linear'];
      case 'shape':
        return ['Circular', 'Rectangular'];
      case 'c_c':
        return ['On', 'Off'];
      case 'c_phi':
        return ['On', 'Off'];
      case 'c_fluid':
        return ['On', 'Off'];
      case 'useSkinLinearFlowTypeCurve':
        return ['On', 'Off'];
      case 'lfSkinModel':
        return ['Constant', 'Variable'];
      case 'temperatureMethod':
        return ['Linear', 'Shiu'];
      case 'pressureMethod':
        return ['Hagedorn & Br.', 'Beggs & Brill'];
      case 'frictionFactorMethod':
        return ['Serghide', 'Chen'];
      default:
        return '';
    }
  } catch (error) {
    console.log(error);
    return "";
  };
};

function getMinMaxStep(param, value, globalUnits) {
  switch(param) {
    case 't_r':
      return [10, 500, 1];
    case 'p_fi':
      return globalUnits === 'metric' ? [500, 100000, 1] : [50, 10000, 0.1];
    case 'h':
      return [10, 500, 0.1];
    case 'c_f':
      return globalUnits === 'metric' ? [0.000001, 0.0001, 0.0000001] : [0.00001, 0.001, 0.000001];
    case 'n_f':
      return [1, 300, 1];
    case 'fracsAttempted':
      return [1, 300, 1];
    case 'w_f':
      return [0.1, 10, 0.01];
    case 'r_w':
      return globalUnits === 'metric' ? [0.0001, 0.5, 0.00001] : [0.1, 1, 0.01];
    case 'g':
      return [0.001, 2, 0.001];
    case 'n2':
      return [0, 100, 0.1];
    case 'co2':
      return [0, 100, 0.1];
    case 'h2s':
      return [0, 100, 0.1];
    case 'gor':
      return [0, 10000, 1];
    case 'cgr':
      return [0.01, 100, 0.01];
    case 'tSep':
      return [0.1, 300, 0.1];
    case 'pSep':
      return [0.1, 1000, 0.1];
    case 'condensateApi':
      return [1, 100, 1];
    case 'gamma':
      return [10, 100, 1];
    case 'solids_bbt':
      return [0, 100, 0.1];
    case 'solids_abt':
      return [0, 100, 0.1];
    case 'phi_m':
      return [0, 100, 0.001];
    case 'phi_f':
      return [0, 100, 0.001];
    case 's_w':
      return [0, 100, 0.1];
    case 's_o':
      return [0, 100, 0.1];
    case 'derivativeWindowRNP':
      return [0.1, 3, 0.1];
    case 'derivativeWindowIRNP':
      return [0.1, 3, 0.1];
    case 'skinChangeParameter':
      return [0.1, 1, 0.1];
    case 'drainageAreaPreBT':
      return globalUnits === 'metric' ? [1, 50000, 0.1] : [0.1, 10, 0.1];
    case 'drainageAreaPostBT':
      return globalUnits === 'metric' ? [1, 50000, 0.1] : [0.1, 10, 0.1];
    case 'pbtMatrixInflow':
      return [10, 10000, 0.1];
    case 'mobileOilSaturation':
      return [0, 100, 0.001];
    case 'mobileGasSaturation':
      return [0, 100, 0.001];
    case 'fractureConductivityPreBT':
      return [1, 500, 0.1];
    case 'fractureConductivityLFTC':
      return [1, 500, 0.1];
    case 'skinPreBT':
      return [0, 50, 0.001];
    case 'skinPostBT':
      return [0, 50, 0.001];
    case 'wtPercentSolidsMatrixInflow':
      return [0, 100, 0.1];
    case 'sqrtTimeFitSlope':
      return globalUnits === 'metric' ? [0.1, 100, 0.01] : [0.1, 5, 0.01];
    case 'sqrtTimeFitIntercept':
      return globalUnits === 'metric' ? [0.001, 200, 0.001] : [0.001, 5, 0.001];
    case 'fmbFitSlope':
      return [-0.0001, 0, 0.0000001];
    case 'fmbFitIntercept':
      return globalUnits === 'metric' ? [0, 1, 0.0001] : [0, 5, 0.01];
    case 'linearDaysStart':
      return [0.01, 1, 0.01];
    case 'linearDaysEnd':
      return [0.01, 1, 0.01];
    case 'linearFlowEndTmb':
      return [0.01, 10, 0.01];
    case 'linearFlowFitIntercept':
    case 'linearFlowFitInterceptI':
      return [0.1, 50000, 0.1];
    case 'multiPhaseFitIntercept':
      return [0.01, 1, 0.001];
    case 'fractureDepletionFitIntercept':
    case 'fractureDepletionFitInterceptI':
      return [0.1, 50000, 0.1];
    case 'kroPostBT':
      return [0.1, 10, 0.1];
    case 'krgPostBT':
      return [0.1, 10, 0.1];
    case 'nPrimePostBT':
      return [0.1, 10, 0.1];
    case 'nPrimePostBTGas':
      return [0.1, 10, 0.1];
    case 'mPrimePostBT':
      return [0.1, 10, 0.1];
    case 'kroMatrixInflow':
      return [0.1, 10, 0.1];
    case 'krgMatrixInflow':
      return [0.1, 10, 0.1];
    case 'kMatrixInflow':
      return [1e-4, 1e-3, 1e-5];
    case 'nPrimeMatrixInflow':
      return [0.1, 10, 0.1];
    case 'nPrimeMatrixInflowGas':
      return [0.1, 10, 0.1];
    case 'mPrimeMatrixInflow':
      return [0.1, 10, 0.1];
    case 'fractureSpacingMatrixInflow':
      return [1, 500, 1];
    case 'formationCompressibility':
      return [1e-6, 1, 1e-5];
    case 'skinMatrixInflow':
      return [0, 10, 0.00000001];
    case 'k_phi_exp':
      return [0.0000001, 0.00001, 0.0000001];
    case 'id':
      return globalUnits === 'metric' ? [0.1, 500, 0.1] : [0.1, 24, 0.1];
    case 'roughness':
      return globalUnits === 'metric' ? [0.0001, 0.1, 0.0001] : [0.0001, 0.01, 0.0001];
    case 'geothermalGradient':
      return [0, 10, 0.01];
    case 'wht':
      return [0, 200, 0.1];
    case 'sgWater':
      return [0.1, 10, 0.001];
    case 'rB':
      return [1, 5000, 0.1];
    case 'errorTolerance':
      return [0, 10, 0.01];
    case 'midPointPerfs':
      return [0, 50000, 0.1];
    case 'loadFluidPumped':
      return [0, 50000, 1];
    default:
      return [Math.pow(10, Math.floor(Math.log10(value))), Math.pow(10, Math.ceil(Math.log10(value))), 0.1];
  };
};

export function getFBAUnit(param, paramUnits, globalUnits) {
  if (globalUnits === 'field') {
    return paramUnits 
  } else {
    return fbaUnits[param] || paramUnits;
  };
};
